import React from 'react';

const SVG = ({ style = {}, colors, width = '100%', viewBox = '0 0 400 400' }) => (
  <svg style={{ ...style, display: 'block' }} width={width} height={width} viewBox={viewBox} xmlns="http://www.w3.org/2000/svg">
    <g>
      <path d="M 67,0 L 332,0 241,99" fill={colors.light} />
      <path d="M 67,0 L 241,99 241,399, 67,299" fill={colors.medium} />
      <path d="M 332,0 L 241,99 241,399 332,299" fill={colors.dark} />
    </g>
  </svg>
);

export default SVG;
